/**
 * SPA page-view tracking. The data router (`createBrowserRouter`) doesn't emit
 * GA4 page views on client navigation — Firebase auto-collects only the initial
 * load. We subscribe to the router and fire `page_view` on each completed
 * navigation, deduping the initial path so it isn't double-counted.
 */

import router from '@/routers';
import { trackPageView } from './analytics';
import { getAttribution } from './attribution';

/**
 * Start GA4 page-view tracking. Fires the INITIAL page_view ourselves (Firebase's
 * auto one is disabled) using the captured landing URL — which still carries the
 * `?utm_*` query the router strips on redirect — so GA4 attributes the session's
 * source/medium/campaign. Then emits a page_view on every client-side route change.
 */
export function startPageViewTracking(): void {
  // Initial landing page_view. Use the captured landing_url (utm intact) as
  // page_location when a campaign was captured; otherwise the current URL.
  const landing = getAttribution()?.landing_url;
  void trackPageView(router.state.location.pathname, undefined, landing);

  let lastPath = router.state.location.pathname + router.state.location.search;
  router.subscribe((state) => {
    // Only count settled navigations, and skip repeats of the same path.
    if (state.navigation.state !== 'idle') return;
    const path = state.location.pathname + state.location.search;
    if (path === lastPath) return;
    lastPath = path;
    void trackPageView(state.location.pathname);
  });
}
